<template>
<div>
    <v-loading type="global" :data="Employees"></v-loading>
    <div class="u-center-block">
        <page-header>
            <slot slot="title">{{ $t('customer.account.users.title') }}</slot>
            <slot slot="description">
                <p>{{ $t('customer.account.users.description') }}</p>
            </slot>
        </page-header>

        <div class="o-wrapper o-wrapper--center">
            <section class="o-page-row--medium">

                <h3 class="u-pull-left">Gebruikers</h3>
                <div class="u-pull-right">
                    <v-add-user
                            @userAdded="addNewUser"
                            :customerKey="0"
                            :roleOptions="[
                                { value: 'Admin', content: 'Beheerder'},
                                { value: 'Vertegenwoordiger', content: 'Vertegenwoordiger'}
                            ]">
                    </v-add-user>
                </div>

                <table-component v-if="Employees.length" class="o-page-row" table-class="c-table c-table--small" :data="Employees" :show-caption="false" :show-filter="false">

                    <table-column key="LastName" :label="$t('customer.account.users.columns.name')" :sortable="false">
                        <template slot-scope="row">
                            {{row.LastName}}
                        </template>
                    </table-column>
                    <table-column key="FirstName" :label="$t('customer.account.users.columns.firstname')" :sortable="false">
                        <template slot-scope="row">
                            {{row.FirstName}}
                        </template>
                    </table-column>
                    <table-column key="Email" :label="$t('customer.account.users.columns.email')" :sortable="false">
                        <template slot-scope="row">
                            {{row.Email}}
                        </template>
                    </table-column>
                    <table-column key="Role" :label="$t('customer.account.users.columns.role')" :sortable="false">
                        <template slot-scope="row">
                            {{row.Role}}
                        </template>
                    </table-column>
                    <table-column cell-class="u-text-nowrap" :label="$t('customer.account.users.columns.blocked')" :sortable="false" :filterable="false">
                        <template slot-scope="row">
                            <div class="o-spacing-tiny">
                                <v-switch v-model="row.IsBlocked" name="blocked" @input="blockUser(row.Id, row.IsBlocked)"></v-switch>
                            </div>
                        </template>
                    </table-column>
                    <table-column cell-class="u-text-nowrap u-text-align-center" :label="$t('customer.account.users.columns.reset')" :sortable="false" :filterable="false">
                        <template slot-scope="row">
                            <button class="c-button c-button--tiny c-button--alpha" @click="resetPassword(row.Email)">
                                <svgicon name="reset" class="svg-icon svg-fill" width="24px" height="24px"></svgicon>
                            </button>
                        </template>
                    </table-column>
                    <table-column cell-class="u-text-nowrap u-text-align-center" :sortable="false" :filterable="false">
                            <template slot-scope="row">
                                <router-link :to="{ name: 'AdminAccountEditUser', query: { 'id': row.Id } }">
                                    <button class="c-button c-button--tiny c-button--alpha" v-if="row.Id !== currentUserId && !row.IsMainAccount">
                                        <svgicon name="user" class="svg-icon svg-fill" width="24px" height="24px"></svgicon>
                                    </button>
                                </router-link>
                            </template>
                        </table-column>
                    <table-column cell-class="u-text-nowrap u-text-align-center" :sortable="false" :filterable="false">
                        <template slot-scope="row">
                            <button class="c-button c-button--tiny c-button--alpha" v-if="row.Id !== currentUserId && !row.IsMainAccount" @click="deleteUser(row.Email)">
                                <svgicon name="cross" class="svg-icon svg-fill" width="24px" height="24px"></svgicon>
                            </button>
                        </template>
                    </table-column>

                </table-component>
                <div v-show="Employees.length" v-else class="u-font-large u-text-align-center u-padding">
                    Geen gebruikers gevonden voor deze klant<br>
                    <span class="u-font-default">Fout in de pagina? Neem contact op met de administrator.</span>
                </div>

            </section>
        </div>

    </div>
</div>
</template>

<script>
    import VLoading from '@/components/Loading'
    import PageHeader from '@/components/common/PageHeader'
    import SideMenu from '@/components/common/SideMenu'
    import SidebarLeft from '@/components/layout/SidebarLeft'
    import VSwitch from '@/components/form/Switch'
    import VAddUser from '@/components/form/userSelect/AddUser'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            SideMenu,
            SidebarLeft,
            VSwitch,
            VAddUser,
            VLoading
        },
        created() {
            this.fetchPage();
        },
        computed: {
            ...mapGetters({
                Employees: 'Employees'
            })
        },
        methods: {
            fetchPage() {
                this.$store.dispatch('getEmployees');
            },
            blockUser(id, state) {
                this.$store.dispatch('blockCustomerUser', {
                    id: this.customerKey,
                    userId: id,
                    body: {
                        IsBlocked: state
                    }
                });
            },
            addNewUser() {
                this.fetchPage();
            },
            resetPassword(email) {
                this.$store.dispatch('forgotPassword', {
                    Email: email
                }).then((response) => {
                    if (response.status > 300) {
                        this.$notify({
                            group: 'global',
                            title: this.$t('global.something_went_wrong'),
                            type: 'error',
                            duration: 5000
                        })
                    } else {
                        this.$notify({
                            group: 'global',
                            title: this.$t('customer.account.forgot.sent_no_instructions'),
                            type: 'success',
                            duration: 5000
                        });
                    }
                });
            },
            deleteUser(email) {
                const confirm = window.confirm(this.$t('customer.account.users.delete'));
                if (confirm) {
                    this.$store.dispatch('deleteUser', {
                        Email: email
                    }).then((response) => {
                        this.$notify({
                            group: 'global',
                            title: this.$t('customer.account.users.deleteSuccess'),
                            type: 'success',
                            duration: 5000
                        });
                        this.fetchPage();
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/admin/account/Users.vue